import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "@/components/Logo";

const links = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/loan-programs", label: "Loan Programs", testid: "nav-programs" },
  { to: "/calculator", label: "Calculator", testid: "nav-calculator" },
  { to: "/resources", label: "Resources", testid: "nav-resources" },
  { to: "/contact", label: "Contact", testid: "nav-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header
      className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm"
      data-testid="site-header"
    >
      {/* Top utility bar */}
      <div className="bg-black text-white text-xs">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-9 flex items-center justify-between">
          <span className="font-sub italic tracking-wide">Insuring Your Future…Today</span>
          <a
            href="tel:+15551234567"
            className="flex items-center gap-2 hover:text-[#00A651] transition-colors"
            data-testid="header-phone"
          >
            <Phone size={14} />
            <span className="hidden sm:inline">Call (555) 123-4567</span>
            <span className="sm:hidden">Call</span>
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="h-20 flex items-center justify-between">
          <Link to="/" data-testid="logo-link" className="block">
            <Logo size={44} />
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={l.testid}
                className={({ isActive }) =>
                  `text-xs uppercase tracking-widest font-bold transition-colors ${
                    isActive ? "text-[#00A651]" : "text-black hover:text-[#00A651]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/apply"
              data-testid="nav-apply-cta"
              className="bg-[#00A651] hover:bg-[#008f45] text-white text-xs uppercase tracking-widest font-bold px-5 py-3 transition-colors rounded-sm"
            >
              Apply Now
            </Link>
          </nav>

          <button
            className="lg:hidden p-2 text-black"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-gray-200 bg-white" data-testid="mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                end={l.to === "/"}
                data-testid={`mobile-${l.testid}`}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm font-bold uppercase tracking-wider rounded-sm transition-colors ${
                    isActive
                      ? "bg-[#00A651]/10 text-[#00A651]"
                      : "text-black hover:bg-gray-50 hover:text-[#00A651]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/apply"
              onClick={() => setOpen(false)}
              data-testid="mobile-apply-cta"
              className="mt-2 bg-[#00A651] hover:bg-[#008f45] text-white text-center text-sm uppercase tracking-wider font-bold px-5 py-3 rounded-sm"
            >
              Apply Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
